export const data5_3 = [{
    outlets: 'Overall Direction 总体方向',
    next_strategy: '',
    next_action_plan:'',
    next_target:'',
    next_deadline:'',
    next_action_by:'',
    third_strategy: '',
    third_action_plan:'',
    third_target:'',
    third_deadline:'',
    third_action_by:'',
    fourth_strategy: '',
    fourth_action_plan:'',
    fourth_target:'',
    fourth_deadline:'',
    fourth_action_by:'',
},{
    outlets: 'Café/All Day Dinning 西餐厅',
    next_strategy: '',
    next_action_plan:'',
    next_target:'',
    next_deadline:'',
    next_action_by:'',
    third_strategy: '',
    third_action_plan:'',
    third_target:'',
    third_deadline:'',
    third_action_by:'',
    fourth_strategy: '',
    fourth_action_plan:'',
    fourth_target:'',
    fourth_deadline:'',
    fourth_action_by:'',
},{
    outlets: 'Chinese Restaurant/Lotus 中餐厅',
    next_strategy: '',
    next_action_plan:'',
    next_target:'',
    next_deadline:'',
    next_action_by:'',
    third_strategy: '',
    third_action_plan:'',
    third_target:'',
    third_deadline:'',
    third_action_by:'',
    fourth_strategy: '',
    fourth_action_plan:'',
    fourth_target:'',
    fourth_deadline:'',
    fourth_action_by:'',
},{
    outlets: 'Specialty Restaurant 特色餐厅',
    next_strategy: '',
    next_action_plan:'',
    next_target:'',
    next_deadline:'',
    next_action_by:'',
    third_strategy: '',
    third_action_plan:'',
    third_target:'',
    third_deadline:'',
    third_action_by:'',
    fourth_strategy: '',
    fourth_action_plan:'',
    fourth_target:'',
    fourth_deadline:'',
    fourth_action_by:'',
},{
    outlets: 'Room Service 送餐服务',
    next_strategy: '',
    next_action_plan:'',
    next_target:'',
    next_deadline:'',
    next_action_by:'',
    third_strategy: '',
    third_action_plan:'',
    third_target:'',
    third_deadline:'',
    third_action_by:'',
    fourth_strategy: '',
    fourth_action_plan:'',
    fourth_target:'',
    fourth_deadline:'',
    fourth_action_by:'',
},{
    outlets: 'Lobby Lounge 大堂酒吧',
    next_strategy: '',
    next_action_plan:'',
    next_target:'',
    next_deadline:'',
    next_action_by:'',
    third_strategy: '',
    third_action_plan:'',
    third_target:'',
    third_deadline:'',
    third_action_by:'',
    fourth_strategy: '',
    fourth_action_plan:'',
    fourth_target:'',
    fourth_deadline:'',
    fourth_action_by:'',
},{
    outlets: 'Club Lounge 行政酒廊',
    next_strategy: '',
    next_action_plan:'',
    next_target:'',
    next_deadline:'',
    next_action_by:'',
    third_strategy: '',
    third_action_plan:'',
    third_target:'',
    third_deadline:'',
    third_action_by:'',
    fourth_strategy: '',
    fourth_action_plan:'',
    fourth_target:'',
    fourth_deadline:'',
    fourth_action_by:'',
},{
    outlets: 'Mini Bar 客房迷你吧',
    next_strategy: '',
    next_action_plan:'',
    next_target:'',
    next_deadline:'',
    next_action_by:'',
    third_strategy: '',
    third_action_plan:'',
    third_target:'',
    third_deadline:'',
    third_action_by:'',
    fourth_strategy: '',
    fourth_action_plan:'',
    fourth_target:'',
    fourth_deadline:'',
    fourth_action_by:'',
},{
    outlets: 'Other Outlets 其他餐厅',
    next_strategy: '',
    next_action_plan:'',
    next_target:'',
    next_deadline:'',
    next_action_by:'',
    third_strategy: '',
    third_action_plan:'',
    third_target:'',
    third_deadline:'',
    third_action_by:'',
    fourth_strategy: '',
    fourth_action_plan:'',
    fourth_target:'',
    fourth_deadline:'',
    fourth_action_by:'',
}];




// WEBPACK FOOTER //
// ./src/components/table/5.0/5-3/data.js